const StoryblokApi = require('../../services/storyblok/storyblok-api')

module.exports.getStory = async (path) => {
  const isPrerenderingEnabled
    = process.env.NODE_ENV === 'production' || process.env.PRERENDER_CONTENT

  if (isPrerenderingEnabled) {
    const data = await StoryblokApi.fetchStory(path)
    return data
  } else
    return { full_slug: path }
}
